module.exports = {
  CHANGE: Symbol("change")
};



// WEBPACK FOOTER //
// ./packages/foundation-ui/src/mount/MountEvent.js